import { render, staticRenderFns } from "./TPStats.vue?vue&type=template&id=7cb6b362"
import script from "./TPStats.vue?vue&type=script&lang=js"
export * from "./TPStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports